import {connect} from 'react-redux';
import ModalShumaFilesList from './ModalShumaFilesList';
import {getFileList} from 'common/actions/files/getFileList';

const mapStateToProps = () => ({});

export default connect(
  mapStateToProps,
  {getFileList}
)(ModalShumaFilesList)
